import Vue from 'vue'
import Vuex from 'vuex'
import { Persona, PersonaDatosLab, PersonaDatosPer, PersonaDatosFam } from '@/models/persona'
import Conexion from '@/services/conexion'
import { Depto, Ciudad, Barrio } from '@/models/ubicaciones'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    queryStatus: false,
    deptos: [new Depto()],
    ciudades: [new Ciudad()],
    barrios: [new Barrio()]
  },
  mutations: {
    setQueryStatus (state, payload) {
      state.queryStatus = payload
    },
    setDeptos (state, payload) {
      state.deptos = payload
    },
    setCiudades (state, payload) {
      state.ciudades = payload
    },
    setBarrios (state, payload) {
      state.barrios = payload
    }
  },
  actions: {
    async exeServicio (context, obj) {
      return Object.assign(new Conexion(), obj).consultar()
    },
    async savePersona (context: any, payload: Persona) {
      let flag = false
      const obj = { request: '/guardar/persona', params: payload, tipo: 'post' }

      return context.dispatch('exeServicio', obj).then(
        (h: any) => {
          if (h.id !== '0' && h.id !== 0) {
            const a = payload.datosLab
              .map(x => { x.persona = h.id; return x })
              .forEach(element => context.dispatch('saveDatosLab', element.datos))
            const b = payload.datosFam
              .map(x => { x.persona = h.id; return x })
              .forEach(element => context.dispatch('saveDatosFam', element.datos))
            const c = payload.datosPer
              .map(x => { x.persona = h.id; return x })
              .forEach(element => context.dispatch('saveDatosPer', element.datos))

            flag = true
          }

          return flag
        }
      )
    },
    saveDatosLab (context: any, payload: PersonaDatosLab) {
      const obj = { request: '/guardar/persona/datos/lab', params: payload, tipo: 'post' }
      return context.dispatch('exeServicio', obj).then((h: any) => h !== null)
    },
    saveDatosFam (context: any, payload: PersonaDatosFam) {
      const obj = { request: '/guardar/persona/datos/fam', params: payload, tipo: 'post' }
      return context.dispatch('exeServicio', obj).then((h: any) => h !== null)
    },
    saveDatosPer (context: any, payload: PersonaDatosPer) {
      const obj = { request: '/guardar/persona/datos/per', params: payload, tipo: 'post' }
      return context.dispatch('exeServicio', obj).then((h: any) => h !== null)
    },
    fetchDeptos (context) {
      const obj = { request: '/consultar/departamentos/todos/', tipo: 'get' }
      context.dispatch('exeServicio', obj).then(
        (h: any) => { context.commit('setDeptos', h) }
      )
    },
    fetchCiudades (context) {
      const obj = { request: '/consultar/ciudades/todos/', tipo: 'get' }
      context.dispatch('exeServicio', obj).then(
        (h: any) => { context.commit('setCiudades', h) }
      )
    },
    fetchBarrios (context) {
      const obj = { request: '/consultar/barrios/todos/', tipo: 'get' }
      context.dispatch('exeServicio', obj).then(
        (h: any) => { context.commit('setBarrios', h) }
      )
    }
  },
  modules: {
  }
})
